export const BACKGROUND_COLOR_MAP = new Map([
  ['Light Grey', '#F4F4F4'],
  ['White', '#FFFFFF'],
]);

export const BACKGROUND_COLOR_CLASS_MAP = new Map([
  ['Light Grey', 'light-grey'],
  ['White', 'white'],
]);
